export default __webpack_public_path__ + "static/media/landing_page_hex_1.03cefdf0.png";